export const parsePhoneNumber = (input: string) => {
  const tempInput = input;

  if (tempInput.length === 10) {
    return `${tempInput.slice(0, 3)}-${tempInput.slice(3, 6)}-${tempInput.slice(
      6,
      10
    )}`;
  } else {
    return `${tempInput.slice(0, 3)}-${tempInput.slice(3, 7)}-${tempInput.slice(
      7,
      11
    )}`;
  }
};

export const parsingPhoneNumber = (num: string) => {
  if (num.length > 13) {
    return num.slice(0, 13);
  }

  return num
    .replace(/[^0-9]/g, "")
    .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
    .replace(/(-{1,2})$/g, "");
};

export const formatPhoneNumber = (num: string): string => {
  const digits = num.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 3) return digits;
  if (digits.length <= 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
};

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  const digits = phoneNumber.replace(/\D/g, "");
  return /^010[1-9]\d{7}$/.test(digits);
};
